import { globals, page as pageIndex } from "../../globals";
import { logOut } from "./auth";
import { showModal } from "./modal";
import { UPDATE_DATA, actionHandler } from "./updateData";

// ------------------------------------
// Constants
// ------------------------------------
export const GET_KEYOWRD_HIGHLIGHT_START = "GET_KEYOWRD_HIGHLIGHT_START";
export const GET_KEYOWRD_HIGHLIGHT_FAILURE = "GET_KEYOWRD_HIGHLIGHT_FAILURE";
export const GET_KEYOWRD_HIGHLIGHT_SUCCESS = "GET_KEYOWRD_HIGHLIGHT_SUCCESS";
export const RETURN_KEYWORD_HIGHLIGHT_INITIAL_STATE =
  "RETURN_KEYWORD_HIGHLIGHT_INITIAL_STATE";

export function getHighlightedDocument(keywords, fileUrl, uploadFile) {
  return (dispatch) => {
    dispatch({ type: GET_KEYOWRD_HIGHLIGHT_START });

    const formData = new FormData();

    formData.append("SearchPhrase", keywords);

    if (uploadFile) {
      formData.append("UploadedFile", uploadFile);
    } else {
      formData.append("URL", fileUrl);
    }

    const options = {
      method: "POST",
      credentials: "include",
      body: formData,
    };

    return fetch(`${globals.apiUrl}/KeywordHits`, options)
      .then((response) => {
        if (response.redirected) {
          return { type: "url", url: response.url };
        }

        if (response.status === 200) {
          return response.text();
        } else if (response.status === 401) {
          dispatch(logOut());
        } else if (response.status === 400) {
          response.text().then((text) => {
            if (text) {
              dispatch({
                type: GET_KEYOWRD_HIGHLIGHT_FAILURE,
                json: text,
              });
              dispatch(showModal("Error"));
            }
          });
        }
      })
      .then((results) => {
        if (results) {
          var bakedResults = results;
          if (!results.url) {
            bakedResults = { type: "html", html: results };
          }

          dispatch({
            type: GET_KEYOWRD_HIGHLIGHT_SUCCESS,
            payload: {
              bakedResults,
            },
          });

          return bakedResults;
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: GET_KEYOWRD_HIGHLIGHT_FAILURE,
          json: "Highlighting document: " + err.message,
        });
        dispatch(showModal("Error"));
      });
  };
}

export function returnInitialState() {
  return {
    type: RETURN_KEYWORD_HIGHLIGHT_INITIAL_STATE,
  };
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_DATA]: (state, action) =>
    action.location.page !== pageIndex.highlighter
      ? state
      : actionHandler(state, action),
  [RETURN_KEYWORD_HIGHLIGHT_INITIAL_STATE]: () => {
    return {
      ...initialState,
    };
  },
  [GET_KEYOWRD_HIGHLIGHT_START]: (state) => {
    return {
      ...state,
    };
  },
  [GET_KEYOWRD_HIGHLIGHT_SUCCESS]: (state) => {
    return {
      ...state,
    };
  },
  [GET_KEYOWRD_HIGHLIGHT_FAILURE]: (state, action) => {
    return {
      ...state,
      errorCode: action.json,
      isError: true,
    };
  },
};
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  errorCode: "",
  isFetchingData: false,
  renderData: {},
  formDataValue: {
    H: {},
  },
};

export default function keywordHighlighterReducer(
  state = initialState,
  action
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/keywordHighlighterFormData.js